var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGainVisibilityInstantly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61729B"
    },
    d: "M256,410.4c-108.145,0-203.074-58.704-253.893-146.552c-2.809-4.856-2.809-10.841,0-15.696 C52.958,160.25,147.92,101.6,256,101.6c108.145,0,203.074,58.704,253.893,146.552c2.809,4.856,2.809,10.841,0,15.696 C459.042,351.75,364.08,410.4,256,410.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57658C"
    },
    d: "M509.893,248.152C459.074,160.304,364.145,101.6,256,101.6V410.4 c108.08,0,203.042-58.651,253.893-146.552C512.702,258.993,512.702,253.007,509.893,248.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEA8C"
    },
    d: "M256,360.49c-57.616,0-104.49-46.874-104.49-104.49S198.384,151.51,256,151.51 S360.49,198.384,360.49,256S313.616,360.49,256,360.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF7C"
    },
    d: "M256,151.51v208.98c57.616,0,104.49-46.874,104.49-104.49S313.616,151.51,256,151.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF7C"
    },
    d: "M256,308.245c-28.808,0-52.245-23.437-52.245-52.245s23.437-52.245,52.245-52.245 s52.245,23.437,52.245,52.245S284.808,308.245,256,308.245z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB630"
    },
    d: "M256,203.755v104.49c28.808,0,52.245-23.437,52.245-52.245S284.808,203.755,256,203.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEFFF"
    },
    d: "M15.673,104.49C7.018,104.49,0,97.472,0,88.816V15.673C0,7.018,7.018,0,15.673,0h73.143 c8.656,0,15.673,7.018,15.673,15.673s-7.018,15.673-15.673,15.673H31.347v57.469C31.347,97.472,24.329,104.49,15.673,104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEFFF"
    },
    d: "M88.816,512H15.673C7.018,512,0,504.982,0,496.327v-73.143c0-8.656,7.018-15.673,15.673-15.673 s15.673,7.018,15.673,15.673v57.469h57.469c8.656,0,15.673,7.018,15.673,15.673C104.49,504.982,97.472,512,88.816,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFED"
    },
    d: "M496.32,104.49c-8.656,0-15.673-7.018-15.673-15.673V31.347h-57.469 c-8.656,0-15.673-7.018-15.673-15.673S414.521,0,423.177,0h73.143c8.656,0,15.673,7.018,15.673,15.673v73.143 C511.994,97.472,504.976,104.49,496.32,104.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFED"
    },
    d: "M496.32,512h-73.143c-8.656,0-15.673-7.018-15.673-15.673c0-8.656,7.018-15.673,15.673-15.673 h57.469v-57.469c0-8.656,7.018-15.673,15.673-15.673c8.656,0,15.673,7.018,15.673,15.673v73.143 C511.994,504.982,504.976,512,496.32,512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainVisibilityInstantly);
export default __webpack_public_path__ + "static/media/gain-visibility-instantly.3ab41c075d88416929183a079dafaad1.svg";
export { ForwardRef as ReactComponent };